module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"completeBooking":{"text":"Complete <strong>Booking Now</strong>","link":"/booking/personal-information"}}}')
  delete Component.options._Ctor
}
